const context = "prestacao-servico";
const abrev = "serv";

export default [
    {
        path: '/serv/formulario/formularios',
        name: 'serv-formulario',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/formulario/FormularioRoute.vue'),
        children: [
            {
                path: '/serv/cockpit',
                name: 'serv-cockpit',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/cockpit/CockpitPrestacaoServico.vue')
            },
            {
                path: 'list',
                name: "serv-formulario-list",
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/formulario/FormularioList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'serv-formulario-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/formulario/FormularioManage.vue'),
                    },
                    {
                        path: 'new/:id',
                        name: 'serv-formulario-duplicate-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/formulario/FormularioManage.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'serv-formulario-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/formulario/FormularioManage.vue'),
                    },
                ]
            }
        ]
    },
    {
        path: '/serv/formulario/formulario-respondido',
        name: 'serv-formulario-respondido',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/relatorio/formulario/RespostaFormularioList.vue'),
        children: [
            {
                path: 'view/:idFormulario',
                name: 'serv-formulario-respondido-view',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/relatorio/formulario/CockpitRespostaFormulario.vue')
            },
        ]
    },
];
